'use strict';

import animations from 'tc-neos-animations';

const init = () => {
    animations.initLenis();
    animations.initScrollReveal();
    animations.initAnchor();
    animations.initParallax();
    animations.initToTop()
}

const scrollToTop = () => {
    animations.scrollToTop();
}

export default {init, scrollToTop}
